import useTranslation from 'next-translate/useTranslation';
import { Box, Flex } from 'rebass';

import { LockIcon } from '@/components/Icon';
import Text from '@/components/Text';

export default function TrustNotice() {
  const { t } = useTranslation('common-feedback');
  return (
    <Flex alignItems="center" justifyContent="center" mb={['0.5rem', '0.5rem', '0.5rem']}>
      <LockIcon />
      <Box verticalAlign="center">
        <Text ml={['0.522rem']} variant="smallBoldWithoutSpace">
          {t('trustContentText')}
        </Text>
      </Box>
    </Flex>
  );
}
